'use client';

import { DisplayCreditCard } from '@/components/DisplayCreditCard/DisplayCreditCard';
import {
  getProductConfigForPresentationRoutes,
  PartnerIdentifier,
  PresentationIdentifier,
  ProductConfigWithSku,
  ProductIdentifier,
} from '@sales-domain/product-config';
import { formatMdn } from '@soluto-private/utils';
import { redirect, useParams, useSearchParams } from 'next/navigation';

export type BillingInfoProp = {
  lastFour?: string;
  brand?: string;
};

export function CustomerPaymentInfo({
  mdn,
  productConfig,
  billingInfo,
  paySessionId,
}: {
  mdn?: string;
  productConfig?: ProductConfigWithSku;
  billingInfo?: BillingInfoProp;
  paySessionId?: string;
}) {
  const searchParams = useSearchParams();
  const params = useParams();

  if (!productConfig && params) {
    productConfig = getProductConfigForPresentationRoutes(
      params.product as ProductIdentifier,
      params.partner as PartnerIdentifier,
      params.presentation as PresentationIdentifier,
    );
  }
  const { lastFour, brand } = billingInfo || {};

  if (productConfig && paySessionId) {
    if (!lastFour || !brand) {
      redirect(`./error?${searchParams}`);
    }
    return <DisplayCreditCard lastFour={lastFour} brand={brand} />;
  }

  return (
    <div className="whitespace-pre-line">
      {productConfig?.name} will appear on your monthly{' '}
      {productConfig?.internalPartner} bill for line number{' '}
      {formatMdn(mdn?.substring(2))}.
    </div>
  );
}
